import { useQuery } from '@apollo/client';
import { Flex, HStack, Stack } from '@chakra-ui/react';
import Body1 from '@components/typography/Body1';
import GET_USER_PROVIDERS from '@gql/GetUserProviders';
import { FilterType } from '../../../utils';
import AddLink from '../../AddLink';
import EditLink from '../../EditLink';
import FilterList from '../../FilterList';

const Providers = ({ primaryProviders, specialistProviders, onFilterChange, user }) => {
  const slug = `providers`;

  const hasDoctors = !!primaryProviders.length || !!specialistProviders.length;

  const { data, previousData } = useQuery(GET_USER_PROVIDERS, {
    variables: {
      userId: user?.id,
    },
  });

  let providerData = [];

  if (data) {
    providerData = data.findUserProviders;
  } else if (previousData) {
    providerData = previousData.findUserProviders;
  }

  return (
    <Flex
      direction="column"
      minWidth={{ lg: '280px' }}
      flexBasis={{ lg: '280px' }}
      flexGrow={1.5}
      overflow="hidden"
      mb={5}
      sx={{
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}
      gap={1}
    >
      <HStack>
        <Body1 bold>Doctors</Body1>
        {hasDoctors && <EditLink slug={slug} />}
      </HStack>
      {hasDoctors ? (
        <Stack spacing={4}>
          <FilterList
            title="Primary"
            type={FilterType.primaryProviders}
            filters={primaryProviders}
            onFilterChange={onFilterChange}
            providerData={providerData}
          />
          <FilterList
            title="Specialists"
            type={FilterType.specialistProviders}
            filters={specialistProviders}
            onFilterChange={onFilterChange}
            providerData={providerData}
          />
        </Stack>
      ) : (
        <Flex w="100%">
          <AddLink slug="providers" />
        </Flex>
      )}
    </Flex>
  );
};

export default Providers;
